import { c as _c } from "react/compiler-runtime";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import CommonCardSkeleton from "@/components/utils/animation/CommonCardSkeleton";
import type { TDHHistory } from "@/entities/ITDH";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { commonApiFetch } from "@/services/api/common-api";
import { useQuery } from "@tanstack/react-query";
import UserPageStatsActivityTDHHistoryCharts from "./UserPageStatsActivityTDHHistoryCharts";
export default function UserPageStatsActivityTDHHistory(t0) {
  const $ = _c(15);
  const {
    profile
  } = t0;
  let t1;
  if ($[0] !== profile.consolidation_key) {
    t1 = [QueryKey.WALLET_TDH_HISTORY, profile.consolidation_key];
    $[0] = profile.consolidation_key;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !!profile?.consolidation_key;
  let t3;
  if ($[2] !== profile.consolidation_key) {
    t3 = async () => {
      const response = await commonApiFetch({
        endpoint: `recent_tdh_history/${profile.consolidation_key}`
      });
      return response;
    };
    $[2] = profile.consolidation_key;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3) {
    t4 = {
      queryKey: t1,
      enabled: t2,
      queryFn: t3
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const {
    isFetching,
    data: tdhHistory
  } = useQuery(t4);
  let content;
  if (isFetching) {
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="tw-mt-2 sm:tw-mt-4 tw-w-full tw-h-96"><CommonCardSkeleton /></div>;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    content = t5;
  } else {
    if (tdhHistory && tdhHistory.length > 0) {
      let t5;
      if ($[9] !== tdhHistory) {
        t5 = <UserPageStatsActivityTDHHistoryCharts tdhHistory={tdhHistory} />;
        $[9] = tdhHistory;
        $[10] = t5;
      } else {
        t5 = $[10];
      }
      content = t5;
    } else {
      let t5;
      if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = <div className="tw-mt-2 lg:tw-mt-4 tw-bg-iron-950 tw-border tw-border-iron-700 tw-border-solid tw-rounded-lg tw-overflow-x-auto"><div className="tw-p-4 sm:tw-px-6 tw-text-sm tw-italic tw-text-iron-500">No TDH history found</div></div>;
        $[11] = t5;
      } else {
        t5 = $[11];
      }
      content = t5;
    }
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="tw-flex"><h3 className="tw-mb-0 tw-text-lg tw-font-semibold tw-text-iron-100">TDH History</h3></div>;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== content) {
    t6 = <div className="tw-mt-4 md:tw-mt-5">{t5}{content}</div>;
    $[13] = content;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}